// extracted by mini-css-extract-plugin
export default {"cardContainer":"profile_cardContainer__-TjCe","showCard":"profile_showCard__NjZVR","editStyle":"profile_editStyle__ETUnM","font20":"profile_font20__8gToy"};